import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogOut, Shield, Award, LogIn } from "lucide-react";
import { NotificationsBell } from "@/components/NotificationsBell";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { AuthDialog } from "@/components/AuthDialog";
import { useTranslation } from "react-i18next";
import { useState } from "react";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [authOpen, setAuthOpen] = useState(false);
  return (
    <>
    <header className="glass sticky top-0 z-40 border-b border-white/10" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <div className="relative mx-auto flex max-w-5xl items-center justify-center px-5 py-3">
        <div className="absolute left-4 top-1/2 flex -translate-y-1/2 items-center gap-1">
          <LanguageSwitcher />
        </div>
        <Logo size="md" />
        <div className="absolute right-4 top-1/2 flex -translate-y-1/2 items-center gap-1">
          {user && <NotificationsBell />}
          {user?.role === "admin" && (
            <Button variant="ghost" size="sm" className="inline-flex rounded-full text-sky-400" onClick={() => navigate("/admin")} data-testid="nav-admin">
              <Shield size={16} className="sm:mr-1" /> <span className="hidden sm:inline">{t("header.admin")}</span>
            </Button>
          )}
          {user ? (
            <Button variant="ghost" size="sm" className="inline-flex rounded-full text-muted-foreground hover:text-foreground" onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout">
              <LogOut size={16} />
            </Button>
          ) : (
            <Button variant="ghost" size="sm" className="inline-flex rounded-full text-sky-400 hover:text-sky-300" onClick={() => setAuthOpen(true)} data-testid="nav-login">
              <LogIn size={16} className="sm:mr-1.5" /> <span className="hidden sm:inline">{t("auth.login", "Se connecter")}</span>
            </Button>
          )}
        </div>
      </div>
    </header>
      {!user && <AuthDialog open={authOpen} onOpenChange={setAuthOpen} initialMode="login" onSuccess={() => setAuthOpen(false)} />}
      {user?.is_ambassador && (
        <div className="w-full bg-black py-2.5 text-center" data-testid="ambassador-badge-global-wrap">
          <span className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-amber-400/70 px-5 py-1.5 text-xl font-bold tracking-wide text-amber-300 shadow-[0_0_16px_-4px_rgba(251,191,36,0.5)] sm:text-2xl" data-testid="ambassador-badge-global">
            <Award size={22} /> {t("ambassador.badge")}
          </span>
        </div>
      )}
    </>
  );
};
